import React from "react";
import slidesAR from "./data/carouselData.json";
import slidesRGWeb from "./data/carouselData.json";
import foxVideos from "./data/carouselData.json";
import Carousel from './carouselAR.js';
import CarouselRG from "./carouselRGWeb.js";
import CarouselFox from "./carouselFox.js";

function Projects(){
    return(
        <div>
            <h1 id = "project-title">Projects</h1>

            <div className="sec-1">
                <h2 id = "pro1-sec1-title">Augmented Human Anatomy</h2>
                <div className="textWindow1-sec1">
                    <div>
                        <p>As a part of my culminating project for my undergraduate degree I was able to collaborate with three other students to elevate an augmented anatomical modeling tool. Using the Unity game engine and the Microsoft Hololens.<br/><br/></p>
                        <ul>
                            <li>I helped bring to life full male and female models</li>
                            <li>Updated UI to include additional bodily structures</li>
                            <li>As well as a fully functional magnifying glass to view the models in more notable detail.</li>
                        </ul>
                    </div>
                    <div>
                        <iframe id="sec1-vid" src="https://www.youtube.com/embed/dzr4PxkiGow?si=Gqgmxt2O-TOE6Eb5" title="Augmented Modeling Tool DemoVideo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
            </div>

            <div className="sec-2">
                <h2 id="pro1-sec2-title">Run Wild Studios</h2>
                <div className="textWindow1-sec2">
                    <p>
                        Run Wild Studios originated out of my passions to create Films & Games for my friends and family to enjoy. 
                        Ever since I was in grade school I have loved to play and watch games/films. 
                        It was not until I reached early adulthood that I began to view them through a new lens. 
                        I figured there was no better way to gain experience in website development than to create a company of my own. 
                        Combining what I love to do best into one culminating projects. Finally allowing others to see the world as I do.
                        <br/>Use this link to view the page:
                        <br/><a href="https://liam-mazure.github.io/Run_Wild/" target="_blank" rel="noreferrer">Click ME</a>
                        <br/><br/>Enjoy! 
                    </p>
                    <div className="picsWindow1-sec2">
                        <img src= {require('./images/Run_Wild_Logo_BlkBck.png')} alt="Run Wild Logo"></img>
                    </div>
                </div>

                <h2 id = "pro2-sec2-title">Running Guide</h2>
                <div id = "textWindow2-sec2">
                        <p>
                            My passion for running led me to pursue a web based application that runners could use as an all in one training diary. 
                            Running Guide allows users to create an account in order to plan out a training plan for specific days of the week, month, and even year. 
                            I utilized the Google maps API to help users find trails to set their sights on the next adventure.
                        </p>
                        <CarouselRG data={slidesRGWeb}/>
                </div>

                <h2 id = "pro3-sec2-title">Jeopardy Study Tool</h2>
                <div id="textWindow3-sec2">
                    <p> Growing up I made it an almost daily ritual to watch and play along with the Jeopardy television show each weeknight competing with my older brother. 
                        I wanted to create a simple and easy way to study the previous 41 seasons of the show on my own. 
                        Allowing me to prepare for my hopeful appearance on the show one day in the future. 
                        I was able to utilize a previous web scraping project to gather the questions to develop this projects main functionality.
                    <br/><br/></p>

                    <video id="sec2-vid" src= {require('./images/JeopardyStudyTool.mp4')} alt = "Jeopardy Game Video" type="video/mp4" controls>
                        Video Unable to Show
                    </video>
                </div>
            </div>

            <div className="sec-3">
                <h2 id = "pro1-sec3-title">Unity Game Development - Traveling Fox</h2>
                <div className="textWindow1-sec3">
                    <p>
                        The Traveling Fox tells the tale of a Fox and its treacherous path to find and save its family at the peak of Mt.Doom.  
                        The player must set off on a journey to find their family and collect the fruits that lie along the way. 
                        Although, the player must be careful as to dodge the sneaky tiger and the hazardous rock slide. 
                        Sit back, relax and navigate the picturesque mountain top view.
                        {/*<br/>
                        During the development of Traveling Fox I was able to accomplish: 
                        <br/>
                        <ul>
                            <li>Opening, ending, and pause menu GUI and event triggers.</li>
                            <li>Rock slide animation loop and event trigger.</li>
                            <li>Background music and spacial sound effects i.e. birds chipping, wind in the trees.</li>
                            <li>Fruit collection with heart retention.</li>
                        </ul>*/}
                    </p>
                    <CarouselFox data={foxVideos}/>
                </div>
            </div>

            <div className="sec-4">
                <h2 id = "pro1-sec4-title">ARCore 3D Model Selector</h2>
                    <div id = "textWindow1-sec4">
                        <p>
                            As a part of my final project for a mobile development course I was challenged with researching an already existing SDK/API and implementing it into a culminating project. 
                            Up to this point in my computing curriculum I had yet to work with AR(Augmented Reality). 
                            I found it fascinating to allow users to interact with the environment around them through the use of AR. 
                            This fascination lead to what you see in front of you today. 
                            This application allows users to select a variety of models and place them directly in front of them. 
                            These models stay where the users selects even if the phones angle changes, allowing the user to orbit each character.
                        </p>
                        <Carousel data={slidesAR}/>
                    </div>
            </div>
            <div className="sec-5">
                <h2 id = "pro1-sec5-title">Jeopardy Web Scraper</h2>
                <div id = "textWindow1-sec5">
                    <p>
                        In order to facilitate my Jeopardy Study Tool I needed the question data to accompany it. 
                        I was able to use Scrapy the Python framework to collect all 41 seasons of question data onto a JSON file. 
                        This made it possible to select only the relevant data to the project at hand, selecting HTML tags using both CSS and XML expressions. 
                        I was then able to recursively call my parse function to only collect the Season/Episode number, Category, Question text, and Question response.
                        Providing all of the data that was needed to populate my study tool. 
                    </p>
                    <div className="picsWindow1-sec2">
                        <img src= {require('./images/JeopardyJsonDataPic.png')} alt="Question Data Pic"></img>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default Projects;